import { render, staticRenderFns } from "./UserLinks.vue?vue&type=template&id=0c51d8a6&"
import script from "./UserLinks.vue?vue&type=script&lang=js&"
export * from "./UserLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports